import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Btn, Portrait, Label, Num, Rule } from '../Common/OkoylUI';

const CLASS_IMAGE = {
    sworder: '/assets/heroes/sworder.png',
    mage:    '/assets/heroes/mage.png',
    archer:  '/assets/heroes/archer.png',
    tank:    '/assets/heroes/tank.png',
};

const CharacterPreview = ({ character, onCharacterChange, onBack, onNext }) => {
    const { t } = useTranslation();
    const [heroName, setHeroName] = useState(character.name || '');

    const handleNameChange = (e) => {
        const name = e.target.value;
        setHeroName(name);
        onCharacterChange({ ...character, name });
    };

    const className = character.classType
        ? t(`characterCreation.classes.${character.classType}.name`)
        : t('characterCreation.step1.noSelection');
    const classImage = CLASS_IMAGE[character.classType] || null;

    const pluralPoint = character.points > 1
        ? t('characterCreation.step2.remainingPointsPlural')
        : t('characterCreation.step2.remainingPointsSingular');

    return (
        <div>
            <h2 className="okcard-title">{t('characterCreation.step3.title')}</h2>
            <Rule thin />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, alignItems: 'start' }}>
                <div>
                    {classImage && (
                        <Portrait src={classImage} name={heroName || t('characterCreation.step3.noClass')} sub={className} />
                    )}
                </div>

                <div>
                    <div style={{ marginBottom: 18 }}>
                        <Label color="muted">{t('characterCreation.step3.fields.name')}</Label>
                        <input
                            type="text"
                            value={heroName}
                            onChange={handleNameChange}
                            placeholder={t('characterCreation.step3.namePlaceholder')}
                            className="okinput"
                            style={{ marginTop: 6 }}
                        />
                    </div>

                    <div style={{ marginBottom: 18 }}>
                        <Label color="muted">{t('characterCreation.step3.fields.voice')}</Label>
                        <div style={{ marginTop: 6, fontFamily: 'var(--font-display)', fontSize: 18, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--okoyl-200)' }}>
                            {className}
                        </div>
                    </div>

                    <div>
                        <Label color="muted">{t('characterCreation.step3.fields.attributes')}</Label>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
                            <Stat label={t('heroStats.labels.strength')}     value={character.attributes?.strength || 0} />
                            <Stat label={t('heroStats.labels.dexterity')}    value={character.attributes?.dexterity || 0} />
                            <Stat label={t('heroStats.labels.intelligence')} value={character.attributes?.intelligence || 0} />
                            <Stat label={t('heroStats.labels.vitality')}     value={character.attributes?.vitality || 0} />
                        </div>
                        {character.points > 0 && (
                            <div style={{ marginTop: 10, fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--crit)' }}>
                                {t('characterCreation.step3.remainingHint', { count: character.points, plural: pluralPoint })}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 28 }}>
                <Btn variant="secondary" onClick={onBack}>◀ {t('common.back')}</Btn>
                <Btn variant="primary" onClick={onNext} disabled={!character.name || character.points > 0}>
                    {t('common.next')} ▶
                </Btn>
            </div>
        </div>
    );
};

const Stat = ({ label, value }) => (
    <div>
        <Label>{label}</Label>
        <div><Num size="md" color="var(--okoyl-200)">{value}</Num></div>
    </div>
);

export default CharacterPreview;
